import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import toast from 'react-hot-toast';



const AdminProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation();

  const token = sessionStorage.getItem("accessToken");
  let isAuthenticated = false;
  let userRole = null;
  let email = null;
  let isTokenExpired = false;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      userRole = decoded.role;
      email = decoded.email;

      const currentTime = Math.floor(Date.now() / 1000);
      if (decoded.exp < currentTime) {
        isTokenExpired = true;
      } else {
        isAuthenticated = true;
      }
    } catch (error) {
      console.error('Error decoding token:', error);
      isAuthenticated = false;
    }
  }

  const isAuthorized = isAuthenticated && allowedRoles.includes(userRole);

  console.log('isAuthenticated:', isAuthenticated);
  console.log('isAuthorized:', isAuthorized);
  console.log('userRole:', userRole);
  console.log('email:', email);
  console.log('isTokenExpired:', isTokenExpired);
  console.log('token:', token);
  console.log('location:', location);
  console.log('allowedRoles:', allowedRoles);
  console.log('decoded:', jwtDecode(token));
  console.log('children:', children);
  useEffect(() => {
    if (isTokenExpired) {
      toast.error('Session expired, please log in again');
      sessionStorage.removeItem("accessToken");
    } else if (isAuthenticated && !isAuthorized) {
      toast.error('You are not authorized to access this page!');
    }
  }, [isTokenExpired, isAuthenticated, isAuthorized]);

  if (!isAuthenticated || !email || isTokenExpired) {
  //  sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    return <Navigate to="/admin/login" />;
  }

  if (!isAuthorized) {
   // sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    return <Navigate to="/admin/login" />;
  }

  return children;
};

export default AdminProtectedRoute;